import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../../admin/i18n/adminI18n';

const { Search } = Input;

@inject('retailOfferStore')
@observer
class SearchMenuItemModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        };
    }

    componentDidMount() {
    }

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Retail'),
                dataIndex: 'taskName',
                key: 'taskName',
                width: '40%'
            },
            {
                title: t('Category'),
                dataIndex: 'parentName',
                key: 'parentName',
                width: '40%'
            },
            {
                title: t('Action'),
                dataIndex: 'taskId',
                key: 'action',
                width: '10%',
                render: taskId => (
                    <span>
                        <Button onClick={() => this.selectSearchMenuItemClicked(taskId)} type='primary'>
                            {t('Select')}
                        </Button>
                    </span>
                ),
            },
        ]
    }

    searchChanged = e => {
        this.props.retailOfferStore.setItemSearchValue(e.target.value);
        this.props.retailOfferStore.searchItem();
    }

    selectSearchMenuItemClicked = taskId => {
        this.props.retailOfferStore.searchItemSelected(taskId);
        this.props.retailOfferStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const {
            lastChildItemFilter,
            itemSearchValue
        } = this.props.retailOfferStore;
        const { t } = this.props;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder={t('Search Retail')} value={itemSearchValue} onChange={this.searchChanged} />
                <Table columns={this.getColumns()} dataSource={lastChildItemFilter} />
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(SearchMenuItemModal)